export default __webpack_public_path__ + "static/media/png-icon.1a0ce119.svg";